import EventBus from '@/services/eventbus';
import events from '@/services/eventbus/events';

/**
 * Vue Plugin is Vue.js plugin.
 * This plugin allows us to inject our services and dependencies to all Vue Components and specs.
 * It's injected into our application in main.js with ``Vue.use(DNAVplugin, { i18n });``.
 * @see https://vuejs.org/v2/guide/plugins.html
 */
const VuePlugin = {
  /**
   *
   * @param myVue
   */
  install: (myVue) => {
    const aVue = myVue;

    aVue.prototype.$eventBus = EventBus;
    aVue.prototype.$events = events;
  },
};
export default VuePlugin;
